import { ImmutableVector3 } from '@modugen/ui-toolkit'

export function signedDistanceInDirectionOf(
  x: ImmutableVector3,
  y: ImmutableVector3,
  direction: ImmutableVector3,
): number {
  return y.sub(x).dot(direction.normalize())
}

export function distanceXY(x: ImmutableVector3, y: ImmutableVector3): number {
  const xXY = new ImmutableVector3(x.x, x.y, 0)
  const yXY = new ImmutableVector3(y.x, y.y, 0)
  return xXY.distanceTo(yXY)
}
